<template>
  <div class="w-full">
    <el-form :model="form" :label-position="labelPosition" :rules="rules" ref="form">
      <CustomerForm :form="form" />
      <el-form-item :gutter="20" class="px-5">
        <el-button type="primary" @click="submit('form')" :loading="adding">Save</el-button>
        <el-button @click="cancelCreate" type="info">Cancel</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>

import CustomerForm from './_includes/CustomerForm.vue';

export default {
  name: 'NewCustomer',
  data() {
    return {
      adding: false,
      labelPosition: 'top',
      rules: this.$store.state.CustomerModule.validate_form,
    };
  },
  components: {
    CustomerForm,
  },
  computed: {
    form() {
      return this.$store.state.CustomerModule.new_customer;
    },
  },
  async mounted() {
    this.setBreadCrumbs(this.$route.meta.breadCrumbs);
  },
  methods: {
    async cancelCreate() {
      this.$router.back();
    },
    submit(form) {
      this.$refs[form].validate(async (valid) => {
        if (valid) {
          try {
            this.adding = true;
            await this.$store.dispatch('CustomerModule/newCustomer', { customer: this.form });
            this.$notify.success({
              title: 'Success',
              message: 'Customer was successfully added.',
            });
            await this.$router.push(`/ecommerce/customers/${
              this.$store.state.CustomerModule.customer.id
            }/details`);
          } catch (e) {
            this.adding = false;
            this.$notify.error({
              title: 'Error',
              message: 'Something went wrong',
            });
          }
          this.adding = false;
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style scoped>

</style>
